export default __webpack_public_path__ + "static/media/Loja integrada.f9e824c4.svg";